export type Member = {
  id: number;
  name: string;
  role: string;
};

export const members: Member[] = [
  { id: 1, name: 'सौ.वर्षाताई दीपक पटले', role: 'सरपंच' },
  { id: 2, name: 'श्री निलेस्वर तेजरामजी कारंजेकर', role: 'उपसरपंच' },
  { id: 3, name: 'कु. साधना टेकचंद बिसेन', role: 'ग्रा.पं.अधिकारी' },
  { id: 4, name: 'श्री रामेश्वर नारायण भगत', role: 'सदस्य' },
  { id: 5, name: 'सौ.ज्योतीताई गौरीशंकर खांडेकर', role: 'सदस्या' },
  { id: 6, name: 'कु.त्रिवेणीताई सत्यवान कटरे', role: 'सदस्या' },
  { id: 7, name: 'श्री रमेश पुरणलाल उके', role: 'सदस्य' },
  { id: 8, name: 'सौ. लताताई अशोकसिंह पवार', role: 'सदस्या' },
  { id: 9, name: 'श्री जितेंद्र नारायण बिसेन', role: 'सदस्य' },
  { id: 10, name: 'सौ. अनिताताई सुभाष भलावी', role: 'सदस्या' },
  { id: 11, name: 'सौ. कलाबाई राजेश शेंडे', role: 'सदस्या' },
];
